/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Sidebar_Delete_Chats_DescInputs */

const es_sidebar_delete_chats_desc = /** @type {(inputs: Sidebar_Delete_Chats_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Estás seguro de eliminar ${i?.count} chats seleccionados? Esta acción no se puede deshacer.`)
};

const en_sidebar_delete_chats_desc = /** @type {(inputs: Sidebar_Delete_Chats_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete ${i?.count} selected chats? This action cannot be undone.`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete {count} selected chats? This action cannot be undone." |
*
* @param {Sidebar_Delete_Chats_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const sidebar_delete_chats_desc = /** @type {((inputs: Sidebar_Delete_Chats_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Delete_Chats_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_sidebar_delete_chats_desc(inputs)
	return en_sidebar_delete_chats_desc(inputs)
});
export { sidebar_delete_chats_desc as "sidebar.delete_chats_desc" }